export default "__VITE_ASSET__d79965c4__"